module.exports = __webpack_public_path__ + "static/media/mainlogo.3f1ba357.jpg";